export default "__VITE_ASSET__B1Yzu1L4__"